import { TActiveAgreementsState } from './types';

export function getListOfAgreements(state: TActiveAgreementsState) {
  return state.listOfAgreements;
}

export function getAgreementsCount(state: TActiveAgreementsState) {
  return state.agreementsCount;
}

export function getIsLoadingCount(state: TActiveAgreementsState) {
  return state.isLoadingCount;
}

export function getAgreementTypes(state: TActiveAgreementsState) {
  return state.agreementTypes;
}
